import { render } from "./InstituteProfile.vue?vue&type=template&id=8f3b6e76&scoped=true"
import script from "./InstituteProfile.vue?vue&type=script&lang=js"
export * from "./InstituteProfile.vue?vue&type=script&lang=js"

import "./InstituteProfile.vue?vue&type=style&index=0&id=8f3b6e76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f3b6e76"]])

export default __exports__